import { SearchEmailResponse } from '@aaa-ncnu-ie/mypolicy-api-registrations';
import { Stack } from '@mui/material';
import { useState } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';

import useUpdateTitle from '../../../../hooks/useUpdateTitle';
import { ClubOrganicRegistrationFormValues } from '../schemas/organicRegistration';

type OTVCValues = Partial<SearchEmailResponse> & {
  codeSent: boolean;
  flow?: 'SMS' | 'Email';
};

type OrganicRegistrationFormContext = {
  formValues: ClubOrganicRegistrationFormValues;
  setFormValues: React.Dispatch<
    React.SetStateAction<ClubOrganicRegistrationFormValues>
  >;
  otvcValues: OTVCValues;
  setOtvcValues: React.Dispatch<React.SetStateAction<OTVCValues>>;
};

export const useOrganicRegistrationForm = () =>
  useOutletContext<OrganicRegistrationFormContext>();

const OrganicRegistration = () => {
  useUpdateTitle('Register for MyPolicy');
  const [formValues, setFormValues] = useState<
    Partial<ClubOrganicRegistrationFormValues>
  >({});
  const [otvcValues, setOtvcValues] = useState<OTVCValues>({
    codeSent: false,
  });

  return (
    <Stack sx={{ width: 1 }}>
      <Outlet
        context={{ formValues, setFormValues, otvcValues, setOtvcValues }}
      />
    </Stack>
  );
};

export default OrganicRegistration;
